import { PaymentsProvider } from '@zorro/clients';
import { useMonolithQuery } from '@zorro/web/ui-utils';

/**
 * Whether an initial allocation exists for a benefit. Lynx-only — Echo
 * has no equivalent concept.
 */
export function useInitialAllocationExistence(
  employeeId: string,
  benefitId?: string,
  paymentsProvider?: PaymentsProvider
) {
  const isLynx = paymentsProvider === PaymentsProvider.LYNX;

  const { data } = useMonolithQuery({
    method: 'paymentsControllerHasInitialAllocation',
    params: benefitId ? [employeeId, benefitId] : undefined,
    enabled: isLynx && !!benefitId,
  });

  return {
    hasExistingAllocation: Boolean(data),
    // data stays undefined until the request actually succeeds — covers
    // still loading, a real error, and a missing benefitId (query disabled)
    // in one check, since none of those should be read as "safe to transfer"
    isCheckingAllocationExistence: isLynx && data === undefined,
  };
}
